export default __webpack_public_path__ + "static/paschoalotto-03df5a1d29dbd85ce64c3a50e1166289.png";